import { render, staticRenderFns } from "./Resources4Users.vue?vue&type=template&id=85697018&scoped=true&"
import script from "./Resources4Users.vue?vue&type=script&lang=js&"
export * from "./Resources4Users.vue?vue&type=script&lang=js&"
import style0 from "./Resources4Users.vue?vue&type=style&index=0&id=85697018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85697018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDataTable,VIcon,VProgressCircular})
